module.exports = __webpack_public_path__ + "img/share_bubble@2x.0b6c2eb4.png";